export const getAttendeePreviewText = (names: string[]): string => {
  if (names.length === 0) return "";

  let nameText = "";
  if (names.length === 1) {
    nameText = names[0];
  } else if (names.length === 2) {
    nameText = `${names[0]} and ${names[1]}`;
  } else {
    nameText = `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  }

  const verb = names.length === 1 ? "is" : "are";
  return `${nameText} ${verb} going`;
};
